import React from 'react';
import './styles.css';
import { Col, Form, InputNumber } from 'antd';

const layout = {
  wrapperCol: { span: 24 },
};

const InputForm = ({ autoFocus, name }) => (
  <Col
    span={6}
    type="flex"
    align="middle"
    justify="center"
    className="input-form-container"
  >
    <Col span={18} type="flex" justify="center">
      <div className="input-form_input-wrapper">
        <Form.Item
          {...layout}
          rules={[
            { required: true, message: 'Campo Requerido' },
            {
              type: 'number',
              min: 0,
              message: 'Debe ser igual o mayor que 0',
            },
          ]}
          style={{ marginRight: 0 }}
          name={name}
        >
          <InputNumber className="input-number" autoFocus={autoFocus} />
        </Form.Item>
      </div>
    </Col>
  </Col>
);

InputForm.defaultProps = {
  name: '',
  description: '',
};

export default InputForm;
